// toggles the active class of an element, triggered by clicking on a link.
// the link needs to have the class js-toggle-active and a data-target attribute
// that contain the css selector of the element to toggle.
// by default, the .active class is toggled. to change the class name,
// add a data-toggle-class attribute to the link.
// by default, the trigger element's .active class is toggled as well. to disable,
// add data-toggle-trigger="false"
// to disable the class when clicking anywhere else on the page,
// add data-click-anywhere-to-disable="true" to the trigger
export function initToggleActive() {
  var triggers = document.querySelectorAll('.js-toggle-active');
  Array.prototype.forEach.call(triggers, function (trigger) {
    trigger.addEventListener('click', toggleActiveHandler);
  });
}

export function toggleActiveHandler(event) {
  var enableDefault = this.dataset.toggleEnableDefault;
  // option for the default behaviour to happen, e.g. for link elements
  if (!enableDefault) {
    event.preventDefault();
  }
  var targetSelector = this.dataset.target;
  var target = document.querySelector(targetSelector);
  var toggleClasses = (this.dataset.toggleClass || 'active').split(/\s+/);
  doToggleClass(this, target, toggleClasses);
  if (this.dataset.clickAnywhereToDisable === 'true') {
    document.addEventListener(
      'click',
      createDisableWhenClickAnywhereCallback(this, target, toggleClasses),
    );
  }
}

function doToggleClass(trigger, target, toggleClasses) {
  toggleClasses.forEach(function (toggleClass) {
    target.classList.toggle(toggleClass);
    if (trigger.dataset.toggleTrigger !== 'false') {
      trigger.classList.toggle(toggleClass);
    }
  });
}

function createDisableWhenClickAnywhereCallback(
  trigger,
  target,
  toggleClasses,
) {
  var callback = function (e) {
    var eventTarget = e.target;
    if (
      trigger !== eventTarget && // did not click on trigger
      !trigger.contains(eventTarget) && // did not click on trigger child
      !target.contains(eventTarget)
    ) {
      // did not click on target child
      doToggleClass(trigger, target, toggleClasses);
      document.removeEventListener('click', callback);
    }
  };
  return callback;
}
